export default __webpack_public_path__ + "static/media/product3.438e9426.png";